import React from "react";
import { Platform } from "react-native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { DrawerContent } from "../components/DrawerContent";
import { Success } from "../pages/SuccessPayment";
import { ClickClass } from "../pages/ClickClass";
import { Video } from "../pages/Video";
import { ClickCard } from "../pages/ClickCard";
import { LiveStream } from "../pages/LiveStream";
import { ClickCourse } from "../pages/ClickCourse";
import { Login } from "../pages/Login";
import { SignUp } from "../pages/SignUp";
import { BlixSignUp } from "../pages/BlixSignUp";
import { ClickSearch } from "../pages/ClickSearch";
import { Plans } from "../pages/Plans";
import { Main } from "../pages/Main";
import { TermsofUse } from "../pages/TermsofUse";
import { About } from "../pages/About";
import { EditProfile } from "../pages/EditProfile";
import { Favorites } from "../pages/Favorites";
import { useAuthUser } from "../contexts/useAuthUser";
import THEME from "../config/theme";
import { hasOutsideAboutPage } from "../config/data";
import { CommunityProvider } from '../pages/Community/ContextCommunity/CommunityContext';
import Community from '../pages/Community';
import { CommunityCommentsScreen } from '../pages/Community/CommunityCommentsScreen';
import { useCustomTheme } from '../contexts/useCustomTheme';
import Checkout from "../pages/Checkout/Checkout";
import PostCheckoutProduct from "../pages/Checkout/PostCheckoutProduct";
import { ProductCatalog } from "../pages/ProductCatalog";

const Stack = createNativeStackNavigator();
const Drawer = createDrawerNavigator();

export function AppRoutes() {
  // Sessão (inclusive o login anônimo) é resolvida uma vez no AuthUserProvider.
  const { isLogged: login } = useAuthUser();

  const CommunityScreen = () => (
    <CommunityProvider>
      <Community />
    </CommunityProvider>
  );

  const { customFont, customColor } = useCustomTheme();

  function DrawerRoutes() {
    return (
      <Drawer.Navigator
        useLegacyImplementation={false}
        drawerContent={(props) => <DrawerContent {...props} />}
        screenOptions={{
          headerShown: false,
          drawerStatusBarAnimation: 'fade',

          // Sem escurecimento de fundo (ver AdminRoutes): o drawer é fixo, então o
          // overlay `absolute` ficava cortado ao rolar. Barra lateral fixa dispensa backdrop.
          overlayColor: 'transparent',

          drawerActiveBackgroundColor:
            customColor && customColor.text && customColor.text.app
              ? customColor.text.app
              : THEME.COLORS.DRAWER_SELECTED,

          drawerActiveTintColor:
            customColor && customColor.background && customColor.background.app
              ? customColor.background.app
              : THEME.COLORS.BACKGROUND_ABOUT,

          drawerInactiveTintColor:
            customColor && customColor.text && customColor.text.app
              ? customColor.text.app
              : THEME.COLORS.DRAWER_SELECTED,

          drawerStyle: {
            backgroundColor:
              customColor &&
                customColor.background &&
                customColor.background.app
                ? customColor.background.app
                : THEME.COLORS.BACKGROUND_ABOUT,
            // Fixa o drawer na viewport na web para não rolar junto com a página
            // (o painel é `position: absolute` no container que rola). Ver AdminRoutes.
            ...(Platform.OS === "web" ? { position: "fixed", height: "100vh" } : {}),
          },

          drawerLabelStyle: {
            fontSize: THEME.FONTSIZE.SMALL,
            fontFamily:
              customFont && customFont.fontFamilyText
                ? customFont.fontFamilyText
                : THEME.FONTFAMILY.REGULAR,
          },
        }}
      >
        <Drawer.Screen name="Aplicativo" component={Main} />
        {login ? (
          <>
            <Drawer.Screen name="Meu Perfil" component={EditProfile} />
            <Drawer.Screen name="Meus Favoritos" component={Favorites} />
          </>
        ) : (
          <Drawer.Screen name="Fazer Login" component={Login} />
        )}
        <Drawer.Screen name="Termos de Uso">
          {() => <TermsofUse />}
        </Drawer.Screen>
      </Drawer.Navigator>
    );
  }

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {!hasOutsideAboutPage ? <Stack.Screen name="Inicio" component={About} /> :
        <Stack.Screen name="Conteudo" component={DrawerRoutes} />
      }
      {!hasOutsideAboutPage ? <Stack.Screen name="Conteudo" component={DrawerRoutes} /> :
        undefined
      }
      {!hasOutsideAboutPage && <Stack.Screen name="Planos" component={Plans} />}
      <Stack.Screen name="Login" component={Login} />
      <Stack.Screen name="Cadastro" component={SignUp} />
      <Stack.Screen name="Cadastro_Blix" component={BlixSignUp} />
      <Stack.Screen name="Modulo" component={ClickCard} />
      <Stack.Screen name="Aula" component={ClickClass} />
      <Stack.Screen name="Watch" component={Video} />
      <Stack.Screen name="Live" component={LiveStream} />
      <Stack.Screen name="Produto" component={ClickCourse} />
      <Stack.Screen name="PoliticaDePrivacidade" component={TermsofUse} initialParams={{ doc: "privacy" }} />
      <Stack.Screen name="Sucesso" component={Success} />
      <Stack.Screen name="MeuPerfil" component={EditProfile} />
      <Stack.Screen name="Favoritos" component={Favorites} />
      <Stack.Screen name="Community" component={CommunityScreen} />
      <Stack.Screen name="CommunityComments" component={CommunityCommentsScreen} />
      <Stack.Screen name="Buscar" component={ClickSearch} />
      <Stack.Screen name="Checkout" component={Checkout} />
      <Stack.Screen name="PostCheckoutProduct" component={PostCheckoutProduct} />
      <Stack.Screen name="CatalogoProdutos" component={ProductCatalog} />
    </Stack.Navigator>
  );
}
